import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import BgIcon from 'assets/images/icons/bg_all_caught.svg';
import ImgIcon from 'assets/images/icons/all_caught.svg';
import OngoingActivity from 'components/OngoingActivity';
import { NoRecommendationsStylized } from './styles';

function NoRecommendations(props) {
  const { literals, resetAll, setBreadcrumb } = props;

  const [showOngoingActivity, setOngoingActivity] = useState(false);

  const handleToggleOngoingActivity = () => {
    setOngoingActivity(!showOngoingActivity);
  };

  // Breadcrumb
  useEffect(() => {
    const breadcrumb = [
      {
        color: '#ffffff',
        text: literals.comebackLater,
      },
    ];

    setBreadcrumb(breadcrumb.slice());
    resetAll();
  }, []);

  return (
    <NoRecommendationsStylized>
      <div className='content'>
        <img src={BgIcon} alt='' className='bg_icon' />
        <img src={ImgIcon} alt='' className='img_icon' />
        <div className='title'>{literals.title}</div>
        <div className='description'>{literals.description}</div>
        <button className='primary' onClick={handleToggleOngoingActivity}>{literals.jumpTo}</button>
      </div>
      {showOngoingActivity ? (
        <React.Fragment>
          <div className='ongoing_title' dangerouslySetInnerHTML={{ __html: literals.yourOngoingActivity }} />
          <OngoingActivity />
        </React.Fragment>

      ) : null}
    </NoRecommendationsStylized>
  );
}

NoRecommendations.propTypes = {
  literals: PropTypes.object.isRequired,
  resetAll: PropTypes.func.isRequired,
  setBreadcrumb: PropTypes.func.isRequired,
};

export default NoRecommendations;



// WEBPACK FOOTER //
// ./src/routes/NoRecommendations/components/index.jsx